import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { Configuration } from '../../../app.constants';
import { WorkgroupService } from '../../services/workgroup-services/workgroup.service';
import {DeletePopupComponent} from '../delete-popup/delete-popup.component';
@Component({
  selector: 'app-list-workgroups-popup',
  templateUrl: './list-workgroups-popup.component.html',
  styleUrls: ['./list-workgroups-popup.component.css']
})
export class ListWorkgroupsPopupComponent implements OnInit {

  public search = '';
  public workgroupList: any;
  public sort = {groupAlias:1}

  constructor(public dialogRef: MatDialogRef<ListWorkgroupsPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public configuration: Configuration,
    public dialog: MatDialog,
    public workhroupService: WorkgroupService,
  ) { }

  ngOnInit() {
    this.workgroupSearch();
  }
  workgroupSearch() {
    this.workhroupService.getWorkGroupFiltered(this.search, 15, 0, '', '', 'Active',this.sort, 'Approved', 'Public').
    subscribe(groups => {
      this.workgroupList = groups['data'];
      console.log('groups', this.workgroupList)
    }, err => {
      console.log(err);
    });
  }

  addWorkgroup(group) {
    if (this.data.list.workgroups.map(function(e) { return e.workgroupId; }).indexOf(group._id) === -1) {
      this.data.workgroups.push(group);
      this.data.list.workgroups.push({workgroupId: group._id});
    }
    this.workgroupList.splice(this.workgroupList.indexOf(group), 1);
  }

  removeWorkgroup(index) {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      width: '400px',
      data: { }
  });
    dialogRef.afterClosed().subscribe(response => {
      if(response === 'Proceed'){
        const group = this.data.workgroups.splice(index, 1 );
        index = this.data.list.workgroups.map(function(e) { return e.workgroupId; }).indexOf(group[0]._id)
        this.data.list.workgroups.splice(index, 1);
        console.log(group);     
      }

    })
  }

  close(){
    this.dialogRef.close();
  }
}
